import axios from 'axios';

async function ObtenerAgenteComercial(prmCodigoAgente: string, prmIdComercial: number = 0) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_comercial"
    
    let datosEnvio;
    
    if (prmCodigoAgente.trim().length > 0) {
        datosEnvio = {"usuario": "mpatti", "clave": "all2GetHer_!", "comercial": prmCodigoAgente}
    } else if (prmIdComercial > 0) {
        datosEnvio = {"usuario": "mpatti", "clave": "all2GetHer_!", "id_comercial": prmIdComercial}
    } else {
        datosEnvio = {"usuario": "mpatti", "clave": "all2GetHer_!"}
    }
    
    try {
        const response = await axios.post(url, datosEnvio);
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerAgenteComercial;